'use client';

import * as React from 'react';
import * as Frigade from '@frigade/react';

interface FrigadeProviderProps {
    apiKey?: string;
    userId?: string;
    userProperties?: {
        email?: string;
        name?: string;
        completedOnboarding?: boolean;
        [key: string]: any;
    };
    children: React.ReactNode;
}

export function FrigadeProvider({
    apiKey,
    userId,
    userProperties,
    children
}: FrigadeProviderProps): React.JSX.Element {
    // Don't render Frigade provider if no API key is provided
    if (!apiKey) {
        console.warn('Frigade API key is missing. Frigade components will not work.');
        return <>{children}</>;
    }

    return (
        <Frigade.Provider
            apiKey={apiKey}
            userId={userId}
            userProperties={userProperties}
            theme={{
                colors: {
                    primary: {
                        surface: 'var(--primary)',
                        border: 'var(--primary)',
                        hover: {
                            surface: 'color-mix(in srgb, var(--primary) 90%, transparent)',
                            border: 'color-mix(in srgb, var(--primary) 90%, transparent)',
                        }
                    }
                }
            }}
        >
            {children}
        </Frigade.Provider>
    );
}

// Re-export Frigade components for easy access
export * from '@frigade/react'; 